import React from "react";
import { Link } from "react-router-dom";
import { routes } from "../../../routes";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import userService from "../../../../services/userService";

interface IHeaderProps {
  logout: () => void;
}

const DeveloperPortalHeader: React.FC<IHeaderProps> = (props) => {
  return (
    <header className="portal-header">
      <div className="breadcrumb">
        <span>Developer Portal</span>
        <span>/</span>
        <span className="active">Settings & Billing</span>
      </div>

      <div className="header-actions">
        <Link 
          to={routes.DASHBOARD} 
          style={{ 
            fontSize: '12px', 
            color: '#64748b', 
            marginRight: '16px', 
            textDecoration: 'none',
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <i className="fa fa-arrow-left" style={{ marginRight: '4px' }}></i>
          Exit Portal
        </Link>

        <div className="env-selector">
          <div className="status-dot"></div>
          <span>sk-jrny_...x8f2</span>
          <span style={{ fontSize: '10px', background: 'rgba(16, 185, 129, 0.1)', color: '#10b981', padding: '2px 4px', borderRadius: '4px', marginLeft: '4px' }}>LIVE</span>
        </div>

        <button className="console-btn">
          <i className="fa fa-terminal"></i>
          <span>_ Console</span>
        </button>

        <div className="notification-bell">
          <i className="fa fa-bell"></i>
          <div className="badge"></div>
        </div>

        <div className="user-profile" style={{ position: 'relative' }}>
          <div className="avatar">J</div>
          <div className="info">
            <div className="name">Journey Dev</div>
            <div className="plan">Basic Plan</div>
          </div>
          <i 
            className="fa fa-sign-out" 
            onClick={() => props.logout()}
            title="Logout"
            style={{ 
              fontSize: '16px', 
              color: '#ef4444', 
              marginLeft: '12px', 
              cursor: 'pointer',
              padding: '4px'
            }}
          ></i>
        </div>
      </div>
    </header>
  );
};

const mapDispatchToProps = {
  logout: userService.logout
};

export default connect(null, mapDispatchToProps)(DeveloperPortalHeader);
